import React from "react";
import {
  Datagrid,
  List,
  Loading,
  TextField,
  TopToolbar,
  DeleteButton,
  EditButton,
  FilterButton,
  FilterForm,
  CreateButton,
  TextInput,
} from "react-admin";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CustomExportButton, CustomImportButton } from "../../Signet/util";

const NetsuiteInlayFinishResource = "netsuite/inlay-finish";

const useStyles = makeStyles({
  container: {
    width: "100%",
    padding: 0,
  },
});

const InlayFinishFilters = [
  <TextInput source="first_inlay_finish" label="First Inlay Finish" />,
  <TextInput source="second_inlay_finish" label="Second Inlay Finish" />,
  <TextInput source="netsuite_id" label="Netsuite ID" />,
  <TextInput source="netsuite_value" label="Netsuite Value" />,
];

const InlayFinishListActions = (props) => {
  const classes = useStyles();
  return (
    <TopToolbar className={classes.container}>
      <Box
        display={"flex"}
        alignItems={"flex-end"}
        justifyContent="space-between"
        width={"100%"}
        sx={{ paddingBottom: "14px", paddingTop: "14px" }}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent="space-between"
        >
          <FilterForm filters={InlayFinishFilters} />
        </Box>
        <Box display={"flex"} justifyItems={"flex-end"} sx={{ gap: "20px" }}>
          <CustomImportButton resource={NetsuiteInlayFinishResource} />
          <CustomExportButton resource={NetsuiteInlayFinishResource} />
          <FilterButton filters={InlayFinishFilters} />
          <CreateButton />
        </Box>
      </Box>
    </TopToolbar>
  );
};

const InlayFinishList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;
  return (
    <List
      {...props}
      exporter={false}
      bulkActionButtons={false}
      actions={<InlayFinishListActions />}
    >
      <Datagrid rowClick={null}>
        <TextField
          source="first_inlay_finish"
          label="First Inlay Finish"
          sortable={false}
        />
        <TextField
          source="second_inlay_finish"
          label="Second Inlay Finish"
          sortable={false}
        />
        <TextField source="netsuite_id" sortable={false} label="Netsuite ID" />
        <TextField
          source="netsuite_value"
          sortable={false}
          label="Netsuite Value"
        />
        <EditButton />
        <DeleteButton label="" undoable={false} />
      </Datagrid>
    </List>
  );
};

export default InlayFinishList;
